import { MatRadioModule } from '@angular/material/radio';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { NoopAnimationsModule } from '@angular/platform-browser/animations';
import { HeaderComponent } from './components/header/header.component';

import { ProductManComponent } from './components/product-man/product-man.component';
import { HolderComponent } from './components/holder/holder.component';
import { MatTableModule } from '@angular/material/table';
import { UserManComponent } from './components/user-man/user-man.component';
import { MatTabsModule } from '@angular/material/tabs';
import { ProductManPreviewComponent } from './components/product-man-preview/product-man-preview.component';
import { ClientsComponent } from './components/clients/clients.component';
import { ProductManSettingsComponent } from './components/product-man-settings/product-man-settings.component';
import { TiketComponent } from './components/tiket/tiket.component';
import { MatPaginatorModule } from '@angular/material/paginator';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './components/login/login.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AuthGuard } from './authGuardClass';
import { ComponentsService } from './components.service';
import { LogInService } from './log-in.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { SettingsGeneralComponent } from './components/settings-general/settings-general.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { PreviewComponent } from './components/preview/preview.component';
import { ProductManTranlsationsComponent } from './components/product-man-tranlsations/product-man-tranlsations.component';
import { MatSelectModule } from '@angular/material/select';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatDatepickerModule } from '@angular/material/datepicker';
import {
    MatNativeDateModule,
    DateAdapter,
    MAT_DATE_FORMATS,
    MAT_DATE_LOCALE
} from '@angular/material/core';
import { CustomDateAdapter } from './shared/custom-date-adapter';
import { RoundNumberPipe } from './round-number.pipe';
import { FilterBarComponent } from './components/filter-bar/filter-bar.component';
import { ConfirmDialogComponent } from './components/confirm-dialog/confirm-dialog.component';
import { PasswordResetComponent } from './components/password-reset/password-reset.component';
import { MatIconModule } from '@angular/material/icon';
import { SideNavbarComponent } from './components/side-navbar/side-navbar.component';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatDialogModule } from '@angular/material/dialog';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatCardModule } from '@angular/material/card';
import { AbstractComponent } from './components/abstract.component';
import { EventService } from './services/event.service';
import { MatRowFocusableDirective } from './directives/mat-row-focusable.directive';
import { MatTableFocusKeyManagerDirective } from './directives/mat-table-focus-key-manager.directive';
import { SettingsComponent } from './components/settings/settings.component';
import { BetSettingsComponent } from './components/bet-settings/bet-settings.component';
import { BreadcrumbModule } from 'xng-breadcrumb';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { MousemoveDetectorDirective } from './directives/mousemove-detector.directive';
import { TimeZoneComponent } from './components/time-zone/time-zone.component';
import { DecimalFormatPipe } from './decimal-pipe.pipe';
import { TruncatePipe } from './truncate.pipe';
import { PayTableInfoComponent } from './components/pay-table-info/pay-table-info.component';
import { CcyManagementComponent } from './components/ccy-management/ccy-management.component';
import { BlockedPlayersComponent } from './components/blocked-players/blocked-players.component';
import { BetstopStatusComponent } from './components/betstop-status/betstop-status.component';
import { TranslationsComponent } from './components/translations/translations.component';
import { ThemeComponent } from './components/theme/theme.component';
import { TicketStatisticsComponent } from './components/ticket-statistics/ticket-statistics.component';
import { TicketSearchPanelComponent } from './components/ticket-search-panel/ticket-search-panel.component';
import { TicketDetailsComponent } from './components/ticket-details/ticket-details.component';
import { DragDropModule } from '@angular/cdk/drag-drop'; // Import DragDropModul
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatChipsModule } from '@angular/material/chips';
import { CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DateTimeZonePipe } from './pipes/date-time-zone.pipe';

@NgModule({
    declarations: [
        AppComponent,
        HeaderComponent,
        ProductManComponent,
        HolderComponent,
        UserManComponent,
        ProductManPreviewComponent,
        ClientsComponent,
        ProductManSettingsComponent,
        TiketComponent,
        LoginComponent,
        SettingsGeneralComponent,
        PreviewComponent,
        ProductManTranlsationsComponent,
        RoundNumberPipe,
        FilterBarComponent,
        ConfirmDialogComponent,
        PasswordResetComponent,
        SideNavbarComponent,
        AbstractComponent,
        MatRowFocusableDirective,
        MatTableFocusKeyManagerDirective,
        SettingsComponent,
        BetSettingsComponent,
        SpinnerComponent,
        MousemoveDetectorDirective,
        TimeZoneComponent,
        DecimalFormatPipe,
        TruncatePipe,
        PayTableInfoComponent,
        CcyManagementComponent,
        BlockedPlayersComponent,
        BetstopStatusComponent,
        TranslationsComponent,
        ThemeComponent,
        TicketStatisticsComponent,
        TicketSearchPanelComponent,
        TicketDetailsComponent,
        DateTimeZonePipe
    ],
    imports: [
        NoopAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        RouterModule,
        FormsModule,
        MatButtonModule,
        MatToolbarModule,
        MatMenuModule,
        MatListModule,
        MatTableModule,
        MatTabsModule,
        MatSortModule,
        MatPaginatorModule,
        MatFormFieldModule,
        MatInputModule,
        HttpClientModule,
        MatCheckboxModule,
        MatSelectModule,
        MatExpansionModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatRadioModule,
        ReactiveFormsModule,
        MatIconModule,
        MatSidenavModule,
        MatDialogModule,
        MatSlideToggleModule,
        MatCardModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        BreadcrumbModule,
        DragDropModule, // Dodaj DragDropModule u imports
        MatChipsModule
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    providers: [
        AuthGuard,
        ComponentsService,
        LogInService,
        EventService,
        DecimalFormatPipe,
        { provide: DateAdapter, useClass: CustomDateAdapter },
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: 'DD/MM/YYYY'
                },
                display: {
                    dateInput: 'DD/MM/YYYY',
                    monthYearLabel: 'MMM YYYY',
                    dateA11yLabel: 'LL',
                    monthYearA11yLabel: 'MMMM YYYY'
                }
            }
        }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
